export const getMenuItems = () => {
  return [
    { key: "1", label: "Ativar " },
    { key: "2", label: " Excluir" },
    { key: "3", label: "Reenviar a mensagem" },
    { key: "4", label: "Andamentos" },
    { key: "5", label: "Vincular cota" },
    { key: "6", label: "Cancelar assinatura" },
  ];
};
